module.exports = __webpack_public_path__ + "static/media/YF41_0.3e1caea8.jpg";